import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import ActivityContentWrapper from "./activity-content-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import ActivityWrapper from "./activity-wrapper";
import { CreditCardIcon } from "@heroicons/react/24/solid";
import useTranslation from "@babackapp/translations/use-translation";

type StoreCreditActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function StoreCreditActivity({ activity }: StoreCreditActivityProps) {
  const t = useTranslation();
  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <CreditCardIcon className="size-3" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <ActivityItemHeader
          title={t("activities.storeCredit.title")}
          timestamp={activity.date}
        />
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
